import React, { useEffect, useState } from 'react';
import Styles from './PropertyField.module.css';

import { Dropdown, DropdownProps, FormLabel, ProviderConsumer } from '@fluentui/react-northstar';
import { useTranslation } from 'react-i18next';
import { AUTOMATION_PROPERTIES, CustomPropertiesAnswerJsonKey } from '../../utils/constants';
import { getTranslateAutomationProperties } from '../../../automation/utils/automationHelper';
import { findAlreadyAddedProperty } from '../../../automation/utils/doPropertyAvailability';

interface Props {
  propertiesList: DropdownDataModel[];
  property: string;
  updateProperty: (property: string) => void;
  whenData?: AutomationWhenData;
  alreadyAddedProperties?: DropdownDataModel[];
}

export const PropertyField = ({
  propertiesList,
  property,
  updateProperty,
  whenData,
  alreadyAddedProperties
}: Props) => {
  const [automationProperty, setAutomationProperty] = useState(property);
  const [searchQuery, setSearchQuery] = useState('');
  const {t} = useTranslation();
  useEffect(() => {
    setAutomationProperty(property);
  }, [property]);

  const automationPropertyChange = (_e, p: DropdownProps) => {
    let data = p.searchQuery;
    if (data === null) return;
    setSearchQuery(data);

    const result = propertiesList.find(x => x.header === p.searchQuery);
    if (result) 
      data = result.key;
    
    setAutomationProperty(data);
    updateProperty(data);
  };

  const removeSpaces = (text: string) => {
    return text?.replace(/\s/g, '');
  };
  propertiesList = propertiesList.filter(x => x.header && x.label);
  
  const getSelectedProperty = (thisProperty) => {
    return propertiesList.find(x => x.key.toLowerCase() == thisProperty.toLowerCase());
  }

  const alreadyAdded = findAlreadyAddedProperty(searchQuery, alreadyAddedProperties?.filter(x => x.header && x.label));
  const noResultsMessage = alreadyAdded
    ? t('automation.property-field.already-added', { property: alreadyAdded.header })
    : t('automation.property-field.we-couldnt-find-any-matches');

  return (
    <ProviderConsumer render={globalTheme =>
      <div className={Styles.GroupInput}>
        <FormLabel content={t('automation.property-field.property')} styles={{ fontSize: '12px' }} />
        <Dropdown
          search
          clearable
          {...(automationProperty && automationProperty.length > 0 && {
            searchQuery: automationProperty.startsWith(`${CustomPropertiesAnswerJsonKey}.`) ? getSelectedProperty(automationProperty)?.label : getTranslateAutomationProperties(removeSpaces(automationProperty)?.toLowerCase(),whenData?.entityName),
            value: getSelectedProperty(automationProperty)
          })}
          noResultsMessage={noResultsMessage}
          inverted
          fluid
          items={propertiesList}
          style={{ backgroundColor: globalTheme.siteVariables.colorScheme.default.background }}
          placeholder={t('automation.property-field.start-typing-a-property')}
          onSearchQueryChange={automationPropertyChange}
          onChange={(e, p) => {
            let data = p.value ? p.value["key"] : '';
            setAutomationProperty(data);
            updateProperty(data);
          }}
        />
      </div>
    } />
  );
};
